import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedConstants } from '@app/eds';

export type chipType =
  
  | 'default'
  | 'default-dark'

  | 'assistive'
  | 'assistive-elevation'
  | 'assistive-icon'
  | 'assistive-elevation-icon'

  | 'filter'
  | 'filter-elevation'
  | 'filter-dropdown'
  | 'filter-elevation-dropdown'
  
  | 'suggestive'
  | 'suggestive-elevation'
  | 'suggestive-icon'
  | 'suggestive-elevation-icon'
  
  | 'status-inactive'
  | 'status-pending'
  | 'status-checked-in'
  | 'status-processing'
  | 'status-ready'
  | 'status-complete'

  ;

export type customStylingType = {
  padding?: string;
  border?: string;
  backgroundColor?: string;
};
@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss']
})
export class ChipComponent {

  // Chip styling class name
  @Input() chipType: chipType = 'default';
  
  // Any valid inline css
  @Input() customStylingOfChipContainer: customStylingType = {};
  
  // To show bluish color chip if its active
  @Input() isFilterChipActive = false;
  
  // To disable the filter chip
  @Input() disableFilterChip = false;
  
  @Input() showAvatar = false;
  
  // IconName, using material icon
  @Input() avatarName: string = SharedConstants.EMPTY_STRING;
  
  // Size of the avatar icon
  @Input() avatarSize: string = SharedConstants.EMPTY_STRING;
  
  // If true then icon will be shown beside text
  @Input() showIcon = false;
  
  // IconName, using material icon
  @Input() iconName: string = SharedConstants.EMPTY_STRING;
  
  // Size of the icon
  @Input() iconSize: string = SharedConstants.EMPTY_STRING;
  
  // To track which chip has been clicked
  @Input() chipId!: number;
  
  @Input() avatarColor: string = "#005dab";
  
  // Event emitter when a chip is being clicked
  @Output() chipClickEvent: EventEmitter<number> = new EventEmitter<number>();

  /**
   * Emits event when a chip has been clicked only
   * when its not disabled
   *
   * @returns {number} chipId of the clicked chip
   */
  onChipClick = () => !this.disableFilterChip && this.chipClickEvent.emit(this.chipId);
}
